import { z } from "zod";
import { PaginatedSearchSchema } from "./paginated-search";

export const ParcelSearchSchema = PaginatedSearchSchema.extend({
  filters: z
    .array(
      z.object({
        id: z.enum(["arrivalDate"]),
        value: z.union([z.string(), z.array(z.string())]),
        variant: z.string(),
        operator: z.string(),
        filterId: z.string(),
      }),
    )
    .optional()
    .default(() => []),
  sort: z
    .enum([
      "id.asc",
      "id.desc",
      "status.asc",
      "status.desc",
      "arrivalDate.asc",
      "arrivalDate.desc",
      "labName.asc",
      "labName.desc",
      "quantity.asc",
      "quantity.desc",
      "contentAmount.asc",
      "contentAmount.desc",
      "anomalousOrders.asc",
      "anomalousOrders.desc",
    ])
    .optional(),
  filtersInitialized: z.boolean().optional(),
});
